import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

export default function BottomBannerSct({ banners }) {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");
  const banner = banners?.filter((banner) => banner?.position == "third")?.[0];
  return (
    <Stack
      sx={{
        position: "relative",
        height: { xs: "300px", md: "450px", xl: "600px" },
        width: "100%",
        backgroundImage: `url('${
          !isMobile
            ? import.meta.env.VITE_URL + banner?.image_desktop?.file_name
            : import.meta.env.VITE_URL + banner?.image_mobile?.file_name
        }')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        mt: 4,
      }}
    >
      {/* Wrapper for centered title */}
      <Stack
        sx={{
          position: "absolute",
          top: "100%",
          transform: "translateY(-50%)",
          left: 0,
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ position: "relative", display: "inline-block" }}>
          {/* Stroke layer with vertical gradient */}
          <Typography
            variant="h1"
            sx={{
              fontWeight: 700,
              position: "absolute",
              top: 0,
              left: 0,
              color: "transparent",
              WebkitTextStrokeWidth: "2px",
              background: `linear-gradient(180deg, white -50%,  ${theme.palette.background.default} 75%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mixBlendMode: "normal",
              fontSize: { xs: "3rem", md: "5rem" },
            }}
          >
            NiMobile Website
          </Typography>

          {/* Main text with theme-based gradient */}
          <Typography
            variant="h1"
            sx={{
              fontWeight: 700,
              background: `linear-gradient(
                180deg, 
                ${theme?.palette?.background?.default} -20%, 
                ${theme?.palette?.background?.default} 70%
              )`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              position: "relative",
              fontSize: { xs: "3rem", md: "5rem" },
            }}
          >
            NiMobile Website
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
}
